import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Button, Badge } from "react-bootstrap";
import ResidentsModal from "../residents/ResidentsModal";
import Equipments from "./Equipments";
import FleetSummaryModal from "./FleetSummaryModal";
import { getMaintenance } from "../../actions/maintenances/maintenances";
import TableToolbar from "../sub/bootstrap/TableToolbar";
import ActionMenu from "../sub/ActionMenu";
import Icon from "../sub/Icon";

class Fleet extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      pendingDeliveryFilter: false,
      pendingRecoveryFilter: false,
    };

    this.props.onGetMaintenance(this.props.user.establishment_id);
  }

  componentDidUpdate(prevProps) {
    // Reset le filtre "À livrer" si les équipements ont changé et qu'il n'y a plus d'équipements à livrer
    if (this.state.pendingDeliveryFilter && prevProps.equipments !== this.props.equipments) {
      const pendingDeliveryCount = this.getPendingDeliveryCount();
      if (pendingDeliveryCount === 0) {
        this.setState({ pendingDeliveryFilter: false });
      }
    }
    // Reset le filtre "À récupérer" si les équipements ont changé et qu'il n'y a plus d'équipements à récupérer
    if (this.state.pendingRecoveryFilter && prevProps.equipments !== this.props.equipments) {
      const pendingRecoveryCount = this.getPendingRecoveryCount();
      if (pendingRecoveryCount === 0) {
        this.setState({ pendingRecoveryFilter: false });
      }
    }
  }

  getPendingDeliveryCount() {
    if (!this.props.equipments) return 0;
    return this.props.equipments.filter(eq => eq.pending_delivery === true).length;
  }

  getPendingRecoveryCount() {
    if (!this.props.equipments) return 0;
    return this.props.equipments.filter(eq => eq.pending_recovery === true).length;
  }

  openResidentsModal() {
    this.setState({
      modal: <ResidentsModal close={() => this.closeModal()} />,
    });
  }

  openSummaryModal(establishmentId) {
    this.setState({
      modal: (
        <FleetSummaryModal
          close={() => this.closeModal()}
          equipments={this.props.equipments}
        />
      ),
    });
  }

  closeModal() {
    this.setState({ modal: null });
  }

  render() {
    let content = null;

    // No equipment yet
    if (this.props.equipments.length === 0) {
      content = (
        <div className="alert alert-secondary" role="alert">
          <FormattedMessage id="Empty.Fleet.Client" />
        </div>
      );
    } else {
      // Equipment in DB
      var MaintenancesToSignArray = [];
      this.props.maintenances.filter((items) => {
        for (let each of this.props.equipments) {
          if (
            items.equipment_id === each._id &&
            items.rep_signature === undefined &&
            items.tech_signature === undefined
          ) {
            MaintenancesToSignArray.push(items.equipment_id);
          }
        }
        return MaintenancesToSignArray;
      });

      content = (
        <Equipments
          equipments={this.props.equipments}
          maintenancesToSign={MaintenancesToSignArray}
          establishmentId={this.props.user.establishment_id}
          pendingDeliveryFilter={this.state.pendingDeliveryFilter}
          pendingRecoveryFilter={this.state.pendingRecoveryFilter}
        />
      );
    }

    let menuItems = [];

    menuItems.push({
      id: null,
      icon: "rectangle-list",
      action: (e) => this.openSummaryModal(this.state.establishmentId),
      text: <FormattedMessage id="Park.Summary" />,
    });
    menuItems.push({
      id: null,
      icon: "person-cane",
      action: (e) => this.openResidentsModal(),
      text: <FormattedMessage id="Residents.Management" />,
    });

    let menuAction = (
      <ActionMenu items={menuItems} size="2xl" className="ml-auto mr-2" />
    );

    const pendingDeliveryCount = this.getPendingDeliveryCount();
    const pendingRecoveryCount = this.getPendingRecoveryCount();

    return (
      <div>
        <div className="text-right" role="alert">
          <TableToolbar>
            {pendingDeliveryCount > 0 && (
              <Button
                variant="warning"
                onClick={() => this.setState({ pendingDeliveryFilter: !this.state.pendingDeliveryFilter, pendingRecoveryFilter: false })}
                className="mr-2"
                style={this.state.pendingDeliveryFilter ? {} : { opacity: 0.7 }}
              >
                <Icon icon="truck" />{" "}
                A livrer{" "}
                <Badge variant={this.state.pendingDeliveryFilter ? "dark" : "light"}>{pendingDeliveryCount}</Badge>
              </Button>
            )}
            {pendingRecoveryCount > 0 && (
              <Button
                variant="info"
                onClick={() => this.setState({ pendingRecoveryFilter: !this.state.pendingRecoveryFilter, pendingDeliveryFilter: false })}
                className="mr-2"
                style={this.state.pendingRecoveryFilter ? {} : { opacity: 0.7 }}
              >
                <Icon icon="box-archive" />{" "}
                A récupérer{" "}
                <Badge variant={this.state.pendingRecoveryFilter ? "dark" : "light"}>{pendingRecoveryCount}</Badge>
              </Button>
            )}
            {menuAction}
          </TableToolbar>
        </div>
        {content}
        {this.state.modal}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    residents: state.residents,
    equipments: state.equipments,
    brands: state.brands,
    models: state.models,
    maintenances: state.maintenances,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetMaintenance: (establishmentId) =>
      dispatch(getMaintenance(establishmentId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Fleet);
